<div *ngIf="showOnLineDetails" class="f-clear"></div>
<h4
  *ngIf="showOnLineDetails && (passDetails?.active?.length > 0 || passDetails?.future?.length > 0)"
  class="m-t-xl"
>
  {{ contentData?.oneTimeCharges }}
</h4>
<div class="p-content">
  <div
    class="row"
    *ngIf="lineUsageSummary?.overages && !isBillingTypePrepaid && !showOnLineDetails"
  >
    <div class="col-12">
      <h5>{{ contentData?.overageCharges }}</h5>
    </div>
  </div>
  <ng-container *ngIf="lineUsageSummary?.overages && !isBillingTypePrepaid && !showOnLineDetails">
    <div class="row m-t-lg">
      <div class="col-12">
        <p class="bold">{{ contentData?.overages }}</p>
      </div>
    </div>
    <div class="row" *ngFor="let usageDetails of lineUsageSummary?.overages">
      <div class="col-8 col-md-9 m-t-md">
        <p class="small">{{ contentData?.roaming }}</p>
      </div>
      <div class="col-4 col-md-3 m-t-md text-end">
        <p class="small">{{ usageDetails?.roaming?.amount | currency: 'USD' : 'symbol-narrow' }}</p>
      </div>
      <div class="col-8 col-md-9 m-t-md">
        <p class="small">{{ contentData?.additionalCharges }}</p>
      </div>
      <div class="col-4 col-md-3 m-t-md text-end">
        <p class="small">
          {{ usageDetails?.additional?.amount | currency: 'USD' : 'symbol-narrow' }}
        </p>
      </div>
      <div class="col-8 col-md-9 m-t-md">
        <p class="bold">{{ contentData?.chargesAlreadyApplied }}</p>
      </div>
    </div>
  </ng-container>
  <div class="row" *ngIf="passDetails?.active?.length">
    <div class="col-12">
      <h5 class="m-t-lg">{{ contentData?.activeOneTimeCharges }}</h5>
    </div>
  </div>
  <div class="row m-t-lg" *ngIf="passDetails?.active?.length > 0">
    <div class="col-12">
      <p class="bold">{{ contentData?.sessionPasses }}</p>
    </div>
    <ng-container *ngFor="let passes of passDetails?.active">
      <div class="col-8 col-md-9 m-t-md">
        <p class="small">{{ passes?.passName }}</p>
      </div>
      <div class="col-4 col-md-3 m-t-md text-end">
        <p class="small">{{ passes?.purchasePrice | currency: 'USD' : 'symbol-narrow' }}</p>
      </div>
    </ng-container>
    <div class="col-8 col-md-9 m-t-lg">
      <p class="bold">{{ contentData?.chargesAlreadyApplied }}</p>
    </div>
    <div class="col-4 col-md-3 m-t-lg text-end">
      <p class="bold">{{ passDetails?.activePassTotal | currency: 'USD' : 'symbol-narrow' }}</p>
    </div>
  </div>
  <div class="row" *ngIf="passDetails?.future?.length && showOnLineDetails">
    <div class="col-12">
      <h5 class="m-t-xl">{{ contentData?.futureOneTimeCharge }}</h5>
    </div>
  </div>
  <div class="row m-t-lg" *ngIf="passDetails?.future?.length > 0 && showOnLineDetails">
    <div class="col-12">
      <p class="bold">{{ contentData?.onDemandPasses }}</p>
    </div>
    <ng-container *ngFor="let passes of passDetails?.future">
      <div class="col-8 col-md-9 m-t-md">
        <p class="small">{{ passes?.passName }}</p>
      </div>
      <div class="col-4 col-md-3 m-t-md text-end">
        <p class="small">{{ passes?.purchasePrice | currency: 'USD' : 'symbol-narrow' }}</p>
      </div>
    </ng-container>
    <div class="col-8 col-md-9 m-t-lg">
      <p class="bold">{{ contentData?.chargesOwed }}</p>
    </div>
    <div class="col-4 col-md-3 m-t-lg text-end">
      <p class="bold">{{ passDetails?.futurePassTotal | currency: 'USD' : 'symbol-narrow' }}</p>
    </div>
  </div>
</div>
